import { Card, Col, Row, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import InfoCardComponent from "../../components/InfoCardComponent";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useCallback, useEffect, useState } from "react";
import { CloseOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import moment from "moment";
import _ from "lodash";
import { addCard, encryptCreditCard, getExpirationCard, removeRecurringSavedCard, updateExpCard } from "../../methods/Methods";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { DispatchAlertConfirmationOpts, ResponseGETConveniosGral } from "../../types/common";
import { AppDispatch } from "../../stores/store";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import { clearAlertConfirmation, setAlertConfirmation, showAlertConfirmation } from "../../stores/slices/alertConfirmationSlice";
import CardInputFields from "../../components/CardInputFields";
const { Text } = Typography;

interface errorFieldsProps {
    creditCard: string,
    expirationCard: string,
}

const PaymentDirect = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const emptyErrorFields: errorFieldsProps = {
        creditCard: "",
        expirationCard: "",
    }
    const [isReset, setIsReset] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    // const [hasError, setHasError] = useState(false);
    const [expirationDateCard, setExpirationDateCard] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    // const [messageInfo, setMessageInfo] = useState("");
    const [idCliente, setIdCliente] = useState("");
    const generalData = useSelector(getGeneralData);
    const [errorsEmptyFields, setErrorsEmptyFields] = useState<errorFieldsProps>(emptyErrorFields);
    const [hasRecurrentPayments, setHasRecurrentPayments] = useState(false);
    const [savedCardMontlyData, setSavedCardMontlyData] = useState<ResponseGETConveniosGral | undefined>();
    const [editingCard, setEditingCard] = useState(false);
    const [payWithThisCard, setPayWithThisCard] = useState(false);
    const [endRecurrentCardSaved, setEndRecurrentCardSaved] = useState("");


    const handleDispatchAlertModal = useCallback((navigateTo: string | null) => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
        if (!_.isNull(navigateTo)) {
            navigate(navigateTo);
        }
    }, [dispatch, navigate]);


    // Manejador para el alert
    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            extraComponents: option.extraComponents,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    const handleCardNumber = (inputValue: string) => {
        errorsEmptyFields.creditCard = "";
        var numberRaw = inputValue.split("-").join("");
        var numberFormated = inputValue.match(new RegExp('.{1,4}', 'g'))?.join("-");
        if (numberRaw.length <= 16) {
            if (numberFormated) {
                setCardNumber(numberFormated);
            } else {
                setCardNumber("");
            }
        }
    }

    const handleExpirationCard = (value: string) => {
        setExpirationDateCard(value.replace(/(\d{2})(\d{2})/, "$1/$2"));
        if (value) {
            errorsEmptyFields.expirationCard = "";
        }
    }

    const validate = () => {
        let error = "";
        let validExpCard = false;

        let errorFields: errorFieldsProps = {
            creditCard: "",
            expirationCard: ""
        }
        if (cardNumber.length < 16) {
            let message = "La tarjeta debe tener 16 dígitos.\n";
            error += message;
            errorFields.creditCard = message;
        }
        if (!cardNumber) {
            let message = "El campo número de tarjeta está vacío.\n";
            error += message;
            errorFields.creditCard = message;
        }
        var reg = new RegExp("(0[1-9]|1[012])/[0-9]{2}");
        if (!expirationDateCard) {
            let message = "El campo fecha de expiración está vacío.\n";
            error += message;
            errorFields.expirationCard = message;
        } else {
            if (reg.test(expirationDateCard)) {
                validExpCard = true;
            } else {
                if (expirationDateCard.indexOf("/") < 0) {
                    let message = "El campo MM/AA es incongruente.\n";
                    error += message;
                    errorFields.expirationCard = message;
                } else {
                    let message = "El campo Mes (MM) y/o año (AA) es incorrecto.\n";
                    error += message;
                    errorFields.expirationCard = message;
                }
            }
            let mes = expirationDateCard.slice(0, 2);
            let mesActual = moment().format("MM");
            let anio = expirationDateCard.slice(3, 5);
            let anioActual = moment().format("YY");

            if (!_.isEmpty(anio) && !_.isEmpty(mes)) {
                if (anio === anioActual && mes < mesActual) {
                    let message = "El mes de la tarjeta ha expirado.\n";
                    error += message;
                    errorFields.expirationCard = message;
                }
                if (anio < anioActual) {
                    let message = "El año de la tarjeta ha expirado.\n";
                    error += message;
                    errorFields.expirationCard = message;
                }
            }
        }

        setErrorsEmptyFields(errorFields);
        if (error !== "") {
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "ERROR",
                title: "¡Estimado Usuario!",
                message: error,
                onFinalize: () => handleDispatchAlertModal(null)
            }
            openAlertModal(dispatchAlert);
            setIsReset(true);
        }

        // Valida si no hay errores y si es valida la expiracion,
        // por lo tanto, la tarjeta es válida
        if (validExpCard && error === "") {
            getCreditCardData();
        }
    }

    const getCreditCardData = async () => {
        let dateExpiration = moment(expirationDateCard, 'MM/YY');
        let cardEncrypted = "";
        let typeStatus = "";
        let messageAlert = "";
        // quita los guiones con los que se guardaba en el input -- split("-").join('')
        await encryptCreditCard(idCliente, cardNumber.split("-").join(''))
            .then((response) => {
                if (response.data && response.data.data[0]) {
                    cardEncrypted = response.data.data[0].creditCardEncrypted;
                }
            })
            .catch(() => { })

        //si ya tiene convenio, solo se actualizan los datos de la tarjeta
        if (hasRecurrentPayments) {
            let requestToUpdate = {
                terminacion: savedCardMontlyData && savedCardMontlyData.tarjeta && savedCardMontlyData.tarjeta.terminacion ? savedCardMontlyData.tarjeta.terminacion : "",
                numero: cardEncrypted,
                anio: dateExpiration.format('YYYY'),
                mes: dateExpiration.format('MM')
            }

            setIsLoading(true);

            await updateExpCard(requestToUpdate, idCliente)
                .then((response) => {
                    if (response.data && response.data.data[0]) {
                        let resp = response.data.data[0];
                        if (!_.isNull(resp.codigo) && resp.codigo === 0) {
                            typeStatus = "SUCCESS";
                            messageAlert = resp.mensaje;
                        } else {
                            typeStatus = "ERROR";
                            messageAlert = response.data.data[0].mensaje ? response.data.data[0].mensaje : "Hubo un error al procesar su solicitud. \nIntente después.";
                        }
                    } else {
                        messageAlert = "Hubo un error al procesar su solicitud. \nIntente después.";
                        typeStatus = "ERROR";
                    }

                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        message: messageAlert,
                        onFinalize: () => handleDispatchAlertModal(("/payments"))
                    }

                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
                .catch(() => {
                    messageAlert = "Hubo un error al procesar su solicitud. \nIntente más tarde.";
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: "ERROR",
                        title: "¡Estimado Usuario!",
                        message: messageAlert,
                        onFinalize: () => handleDispatchAlertModal(null)
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
        }
        //si no tiene convenio, se agrega la tarjeta para domiciliarla
        else {
            let requestToAdd = {
                numero: cardEncrypted,
                anio: dateExpiration.format('YYYY'),
                mes: dateExpiration.format('MM')
            };
            setIsLoading(true);
            await addCard(requestToAdd, idCliente)
                .then((response) => {
                    if (response.data && response.data.data[0]) {
                        let resp = response.data.data[0];
                        if (!_.isNull(resp.codigo) && _.isEqual(resp.codigo, "0")) {
                            typeStatus = "SUCCESS";
                            messageAlert = resp.mensaje;
                        } else {
                            typeStatus = "ERROR";
                            messageAlert = response.data.data[0].mensaje ? response.data.data[0].mensaje : "Hubo un error al procesar su solicitud. \nIntente después.";
                        }
                    } else {
                        messageAlert = "Hubo un error al procesar su solicitud. \nIntente después.";
                        typeStatus = "ERROR";
                    }
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: typeStatus as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        message: messageAlert,
                        onFinalize: () => handleDispatchAlertModal("/payments")
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                })
                .catch(() => {
                    messageAlert = "Hubo un error al procesar su solicitud. \nIntente más tarde.";
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: "ERROR",
                        title: "¡Estimado Usuario!",
                        message: messageAlert,
                        onFinalize: () => handleDispatchAlertModal(null)
                    }
                    openAlertModal(dispatchAlert);
                    setIsLoading(false);
                });
        }
    };

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            const newIdCliente = generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor;
            setIdCliente(newIdCliente);

        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            setIsLoading(true);
            getExpirationCard(idCliente)
                .then((response) => {
                    if (response.data && response.data.data[0] && !_.isNull(response.data.data[0].tarjeta) && response.data.data[0].codigo !== "902") {
                        // Si el campo tarjeta no está null es porque tiene tarjeta domiciliada
                        // Y si es diferente del cod 902
                        setHasRecurrentPayments(true);
                        setSavedCardMontlyData(response.data.data[0]);
                        setEndRecurrentCardSaved(response.data.data[0].tarjeta.terminacion);
                    } else {
                        setHasRecurrentPayments(false);
                        setSavedCardMontlyData(undefined);
                    }
                    setIsLoading(false);
                })
                .catch(() => {
                    setHasRecurrentPayments(false);
                    setSavedCardMontlyData(undefined);
                    setIsLoading(false);
                });
        }
    }, [idCliente]);


    const closeUpdateCard = () => {
        setEditingCard(false);
        setPayWithThisCard(false);
        setErrorsEmptyFields(emptyErrorFields);
    }


    const onPressBtnPrimary = useCallback(() => {
        dispatch(showAlertConfirmation(false));
        dispatch(clearAlertConfirmation());
        setIsLoading(true);
        removeRecurringSavedCard(idCliente)
            .then((response) => {
                let dispatchStatusPay: AlertSliceInterface = {
                    show: true,
                    type: response.data.data[0].status ? "SUCCESS" : "ERROR" as "INFO" | "SUCCESS" | "ERROR",
                    title: "¡Estimado Usuario!",
                    message: response.data.data[0].message,
                    onFinalize: () => handleDispatchAlertModal((response.data.data[0].status ? "/payments" : null))
                }
                openAlertModal(dispatchStatusPay);
                setIsLoading(false);
            })
            .catch(() => {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: "Hubo un error al procesar su solicitud. \nIntente más tarde.",
                    onFinalize: () => handleDispatchAlertModal(null)
                }
                openAlertModal(dispatchAlert);
                setIsLoading(false);
            })
    }, [dispatch, handleDispatchAlertModal, idCliente, openAlertModal]);

    const onPressBtnSecondary = useCallback(() => {
        dispatch(showAlertConfirmation(false));
        dispatch(clearAlertConfirmation());
    }, [dispatch]);

    const openAlertModalConfirm = useCallback((option: DispatchAlertConfirmationOpts) => {
        dispatch(setAlertConfirmation({
            show: true,
            onPressBtnPrimary: option.onPressBtnPrimary,
            onPressBtnSecondary: option.onPressBtnSecondary,
            message: option.message
        }));
    }, [dispatch]);



    const handleDeleteSavedCard = () => {
        let dispatchAlert: DispatchAlertConfirmationOpts = {
            onPressBtnPrimary: () => onPressBtnPrimary(),
            onPressBtnSecondary: () => onPressBtnSecondary(),
            message: "¿Está seguro que desea eliminar la tarjeta del pago domiciliado con terminación " + endRecurrentCardSaved + "?"
        }
        openAlertModalConfirm(dispatchAlert);
    }

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Domiciliar Pago"} needReturn={true} navigateTo={"/payments"}>
                        <div style={{ marginTop: 20 }}>
                            {
                                <>
                                    <InfoCardComponent title="¡Estimado usuario!" description="Por el momento no aceptamos pagos con American Express." />
                                    {
                                        hasRecurrentPayments ?
                                            <Row justify={"center"}>
                                                <Col xs={16} xl={14} >
                                                    <Card style={styles.divRoot2}>
                                                        <div>
                                                            <Text style={styles.textPrincipal}>
                                                                Actualmente tu pago está domiciliado
                                                            </Text>
                                                        </div>
                                                        <div>
                                                            <Text style={styles.textRegular}>
                                                                Puedes actualizar tus datos
                                                            </Text>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            :
                                            null
                                    }
                                    {
                                        hasRecurrentPayments ?
                                            <Row justify={"center"}>
                                                <Col xs={16} xl={14}>
                                                    <Card style={styles.cardViewRoot}>
                                                        <Row>
                                                            <Col xs={19}>
                                                                <div style={styles.textTitle}>{"************" + endRecurrentCardSaved}</div>
                                                            </Col>
                                                            <Col xs={5}>
                                                                {
                                                                    !editingCard && !payWithThisCard ?
                                                                        <>
                                                                            <Row justify={"end"} gutter={[12, 12]}>
                                                                                <Col>
                                                                                    <EditOutlined style={styles.icon} onClick={() => setEditingCard(!editingCard)} />
                                                                                </Col>
                                                                                <Col>
                                                                                    <DeleteOutlined style={styles.icon} onClick={() => handleDeleteSavedCard()} />
                                                                                </Col>
                                                                            </Row>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <Row justify={"end"} gutter={[12, 12]}>
                                                                                <Col>
                                                                                    <CloseOutlined style={styles.icon} onClick={closeUpdateCard} />
                                                                                </Col>
                                                                            </Row>
                                                                        </>
                                                                }
                                                            </Col>
                                                            <Col>
                                                                {
                                                                    editingCard ?
                                                                        <div style={{ marginTop: 20 }}>
                                                                            <CardInputFields
                                                                                cardNumber={cardNumber}
                                                                                expirationDateCard={expirationDateCard}
                                                                                handleCardNumber={handleCardNumber}
                                                                                handleExpirationCard={handleExpirationCard}
                                                                                errorsEmptyFields={errorsEmptyFields}
                                                                                isReset={isReset}
                                                                                validate={validate}
                                                                            />
                                                                        </div>
                                                                        : payWithThisCard ?
                                                                            <Row justify={"space-evenly"} style={styles.rowViewPaymentData} gutter={[12, 12]}>
                                                                                <Col xs={24} xl={10}>
                                                                                    <Text style={styles.inputTitle}>Vencimiento</Text>
                                                                                </Col>
                                                                                <Col xs={24} xl={10}>
                                                                                    <Text style={styles.inputTitle}>CVV</Text>

                                                                                </Col>
                                                                            </Row>
                                                                            :
                                                                            null
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            :
                                            <Row justify={"center"}>
                                                <Col xs={16} xl={14}>
                                                    <Card style={styles.viewRoot} bodyStyle={styles.bodyCard}>
                                                        <CardInputFields
                                                            cardNumber={cardNumber}
                                                            expirationDateCard={expirationDateCard}
                                                            handleCardNumber={handleCardNumber}
                                                            handleExpirationCard={handleExpirationCard}
                                                            errorsEmptyFields={errorsEmptyFields}
                                                            isReset={isReset}
                                                            validate={validate}
                                                        />
                                                    </Card>
                                                </Col>
                                            </Row>
                                    }
                                </>
                            }
                        </div>
                    </SubDefaultLayout>
            }
        </>
    );
};

const styles = StyleSheet.create({
    viewRoot: {
        width: "100%",
        display: 'flex',
        alignItems: 'center',
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 12,
        marginTop: 25
    },
    bodyCard: {
        width: "100%",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 15,
        marginBottom: 15
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputText: {
        marginTop: 10,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    imageStyle: {
        width: 100,
        height: 40,
        paddingLeft: 5
    },
    divRootImg: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginTop: 10,
        alignItems: "center",
    },
    emptyFieldError: {
        fontSize: 11
    },
    textPrincipal: {
        color: "white",
        fontSize: 20,
        fontWeight: 600,
    },
    textRegular: {
        color: "white",
        fontSize: 15,
    },
    cardRoot: {
        backgroundColor: "white",
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20,
    },
    rowCardPrincipal: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center',
    },
    divRoot2: {
        borderRadius: 18,
        textAlign: "center",
        backgroundColor: "#002f97",
        marginTop: 15,
        marginBottom: 15
    },
    cardViewRoot: {
        backgroundColor: 'white',
        borderRadius: 15,
        marginBottom: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)"
    },
    textTitle: {
        fontSize: 15,
        color: "#767b81",
        fontWeight: 600,
    },
    icon: {
        fontSize: 15,
        color: "#767b81"
    },
    colCardNumber: {
        width: "100%",
        justifyContent: 'center',
        display: 'flex',
        marginTop: 10
    },
    rowViewPaymentData: {
        marginTop: 10
    },
    inputContainer: {
        width: "80%",
    },
});

export default PaymentDirect;
